// extracted by mini-css-extract-plugin
export default {"root":"UserProfileBalance_root__eJI29"};